export default __webpack_public_path__ + "static/media/WaterproofBoots.a48e94f8.png";